import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=74f90a1e&scoped=true&"
import script from "./JobDetail.vue?vue&type=script&lang=ts&"
export * from "./JobDetail.vue?vue&type=script&lang=ts&"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=74f90a1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f90a1e",
  null
  
)

export default component.exports